
import {Component, Prop, Vue} from "vue-property-decorator";
import {IApp} from "@/interfaces/app.interface";
import {IBook} from "@/interfaces/book.interface";
import {ICarList} from "@/modules/CarList/interfaces/car-list.interface";
import moment from "moment";
import {bus} from "@/plugins/bus";
import {IDialog} from "@/modules/Popup/interfaces/dialog.interface";
import {IReport} from "@/modules/Report/interfaces/report.interface";
import {KeyboardMobileHidden} from "@/plugins/keyboard-mobile-hidden";
import {IAppState} from "@/interfaces/app-state.interface";
import AppCorpsFilter from "@/components/FormControls/AppCorpsFilter.vue";

  @Component({
    components: {AppCorpsFilter}
  })
  export default class MovementForm extends Vue {
    @Prop() closePopup: Function;

    format = IApp.DATE_TIME_FORMAT_ELEMENT_UI;
    dateFormats = IApp.DateFormats;
    addMode = true;
    defaultValues = {
      movId: null,
      corpId: null,
      corpName: '',
      carNumber: '',
      dateIn: '',
      dateOut: '',
      comment: '',
      tSum: null,
      cash: 0,
      payGuestHoursMov: null,
      unknownCarFlag: false,
      movsRecalcFlag: false,
      visitPurposeId: null,
      parkId: null,
      payCashFlag: false,
    };
    formModel: any = {};
    pickerOptions = IApp.DatePickerOptions.Simple;

    get storeState(): IAppState { return this.$store.state; }
    get disableAction() { return !this.formModel.carNumber; }
    get visitPurposeTypes(): IBook.CatalogData[] { return this.storeState.book.books[IBook.BookName.visitPurposeTypes]; }
    get parks(): IBook.ParkBookItem[] { return this.storeState.book.books[IBook.BookName.parks]; }
    get payloadPopup() { return this.storeState.dialog.payload.reports.reportMovementsChange; }

    created() {
      this.addMode = !Boolean(this.payloadPopup.movId);
      this.formModel = this.addMode
        ? {
          ...this.defaultValues,
          ...this.payloadPopup,
        }
        : {
          ...this.payloadPopup,
          dateIn: this.payloadPopup.dateIn ? moment(this.payloadPopup.dateIn).format(this.dateFormats.PrintedDateTimeFull) : '',
          dateOut: this.payloadPopup.dateOut ? moment(this.payloadPopup.dateOut).format(this.dateFormats.PrintedDateTimeFull) : '',
          payGuestHoursMov: this.payloadPopup.payGuestHoursMov > 0 ? this.payloadPopup.payGuestHoursMov : null,
          cash: this.payloadPopup.paySum ? this.payloadPopup.paySum : 0,
          movsRecalcFlag: true,
          tSum: this.payloadPopup.payCashFlag ? this.payloadPopup.driverSum : this.payloadPopup.tSum,
        };

      if (!this.addMode) {
        Object.keys(this.formModel).forEach((key) => this.defaultValues[key] = this.formModel[key]);
      }

      KeyboardMobileHidden();
    }

    async saveMovement() {
      if (this.disableAction) return;

      // Calculate movsRecalcFlag.
      if (this.formModel.dateIn !== this.defaultValues.dateIn || this.formModel.dateOut !== this.defaultValues.dateOut) {
        this.formModel.movsRecalcFlag = true;
      }
      if (this.formModel.tSum !== this.defaultValues.tSum) {
        this.formModel.movsRecalcFlag = false;
      }

      let params = {
        command: this.addMode ? ICarList.CommandsMovements.Add : ICarList.CommandsMovements.Update,
        form: { ...this.formModel },
      };
      if (this.formModel.dateIn) params.form.dateIn = moment(this.formModel.dateIn, IApp.DateFormats.PrintedDateTimeFull).format(IApp.DateFormats.ToServer);
      if (this.formModel.dateOut) params.form.dateOut = moment(this.formModel.dateOut, IApp.DateFormats.PrintedDateTimeFull).format(IApp.DateFormats.ToServer);
      if (!this.addMode) params.form['movId'] = this.payloadPopup.movId;

      let success = await this.$store.dispatch('carList/actionReportMovements', params);
      if (success) {
        const fromCarPopup = this.payloadPopup.fromCarPopup;
        if (fromCarPopup) bus.$emit(IDialog.Events.CAR_POPUP_UPDATE_MOVEMENTS);
        else {
          const payload: any = { reportName: IReport.ReportName.Movement };
          if (!fromCarPopup) payload.filters = {...this.storeState.report.filters};
          await this.$store.dispatch('report/getReport', payload);
        }
        this.closePopup();
      }
    }

    copyDate(from: string, to: string) {
      this.formModel[to] = this.formModel[from];
    }
  }
